/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* Copyright (c) 2020 IceRock MAG Inc. Use of this source code is
governed by the Apache 2.0 license. */

import React, { FC, useState } from 'react';
import styles from './styles.module.scss';
import { t } from '../../../../../i18n';
import { usePathPrefix } from '../../../../../constants/hooks';

interface IProps {}

const KmmFAQ: FC<IProps> = () => {
  const arrQuestions = [1, 2, 3, 4, 5, 6, 7, 8];

  return (
    <div className={styles.wrap}>
      <a id="faq" />
      <div className={styles.FAQ_block}>
        <h2>{t('cases.cource.faq.title')}</h2>
        <div className={styles.questions}>
          {arrQuestions.map((number) => (
            <KmmQuestions key={number.toString()} index={number.toString()} />
          ))}
        </div>
      </div>
    </div>
  );
};

const KmmQuestions = ({ index }: { index: string }) => {
  const prefix = usePathPrefix();
  const [isActive, setActive] = useState(false);

  const toogleActive = () => {
    if (isActive) {
      setActive(false);
    } else {
      setActive(true);
    }
  };

  return (
    <div className={styles.question}>
      <button
        onClick={() => {
          toogleActive();
        }}
        className={styles.button_question}
      >
        {t(`cases.cource.faq.question_${index}`)}
        {isActive ? (
          <div className={styles.arrow_wrap}>
            <img
              src={`${prefix}/case/design/arrowToDown.svg`}
              alt="arrowToDown"
            />
          </div>
        ) : (
          <div className={styles.arrow_wrap}>
            <img
              src={`${prefix}/case/design/arrowToUp.svg`}
              alt="arrowToDown"
            />
          </div>
        )}
      </button>
      {isActive ? (
        <p className={styles.answer}>{t(`cases.cource.faq.answer_${index}`)}</p>
      ) : (
        <></>
      )}
    </div>
  );
};

export { KmmFAQ };
